import {useNavigate} from "react-router-dom"
import {ChatItem} from "../../../features/chat/api/chat.api"
import {Avatar} from "../../../shared/ui/Avatar"
import {renderLastMessage, formatDate} from "../utils"
import {AcademicCapIcon} from "@heroicons/react/16/solid"

export const DirectChatsList = ({chats}: { chats: ChatItem[] }) => {
    const navigate = useNavigate()

    if (!chats.length) {
        return <div className="p-6 text-gray-500">No direct chats yet</div>
    }

    return (
        <div className="space-y-3 max-w-4xl">
            {chats.map((chat) => {
                const peer = chat.peer
                const name = peer?.display_name || peer?.full_name || peer?.email

                return (
                    <div
                        key={chat.id}
                        onClick={() =>
                            navigate(`/chats/${chat.id}/history`, {
                                state: {
                                    peerId: peer?.user_id,
                                    peer,
                                    courseId: chat.course_id || undefined,
                                },
                            })
                        }
                        className="
        cursor-pointer
        bg-white
        border
        rounded-2xl
        px-5 py-4
        flex items-center justify-between
        transition
        hover:shadow-md
        hover:border-emerald-200
    "
                    >
                        <div className="flex items-center gap-4 min-w-0">
                            <Avatar name={name} src={peer?.avatar} size={44}/>
                            <div className="min-w-0">
                                <div className="flex items-center gap-2">
                                    <div className="text-sm font-semibold text-gray-900 truncate">
                                        {name || "Пользователь"}
                                    </div>
                                    {chat.course_title && (
                                        <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] font-medium bg-violet-50 text-violet-600 ring-1 ring-violet-100 flex-shrink-0 truncate max-w-[160px]">
                                            <AcademicCapIcon className="w-3 h-3 flex-shrink-0" />
                                            <span className="truncate">{chat.course_title}</span>
                                        </span>
                                    )}
                                </div>

                                <div className="text-sm text-gray-500 truncate max-w-md">
                                    {renderLastMessage(chat.last_message)}
                                </div>
                            </div>
                        </div>

                        <div className="text-xs text-gray-400 whitespace-nowrap">
                            {formatDate(chat.last_message_at)}
                        </div>
                    </div>
                )
            })}
        </div>
    )
}
